<template>
  <div
    class="root"
    @keyup.enter="onClickLoginBtn"
    style="width: 20rem; margin: 0 auto; margin-top: 18%"
  >
    <el-form label-width="80px">
      <el-form-item label="用户名">
        <el-input
          v-model="username"
          maxlength="20"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model="password"
          maxlength="20"
          type="password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="onClickLoginBtn"
          type="primary"
          style="margin-left: 5rem"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const axios = require("axios");
import util from "../util";

export default {
  data() {
    return {
      username: "", // 用户名
      password: "", // 密码
    };
  },

  methods: {
    /**
     * 点击了登录按钮
     */
    async onClickLoginBtn() {
      let username = this.username.trim();
      let password = this.password.trim();
      if (username.length == 0) {
        this.$message.error("请输入有效用户名");
        return;
      }
      if (password.length == 0) {
        this.$message.error("请输入有效密码");
        return;
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/account/login`,
          {
            username: username,
            password: password,
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        message: "登录成功",
        type: "success",
      });

      // token
      let token = resData.data.token;

      // 记录登录状态
      util.storeToLocalStorage(
        "loginUser",
        {
          username: username,
          isLogin: "1",
          token: token,
        },
        60 * 60 * 24 * 1
      );

      // 跳转到首页
      return this.$router.push({ path: "/" });
    },
  },
};
</script>